import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import noneImage from '../../../assets/none-png-2.png'
import { moviesApi, tvApi } from '../../../api'

const Root = styled.div`
    border-radius:0 0 5px 5px;
    width:100%;
    background:rgba(255,255,255,0.2);
    overflow: auto;
        -ms-overflow-style: none;
        &::-webkit-scrollbar {
            background:rgba(0,0,0,0.1)
        }
        &::-webkit-scrollbar-thumb {
            background: rgba(255,255,255,0.2);
    }
        &::-webkit-scrollbar-thumb:hover {
            background: rgba(255,255,255,0.5);
    }
    @media screen and (max-width:768px) {
        background:rgba(255,255,255,0.2);
    }
    animation:loadRoot 1s ease-in-out;
    max-height:200px;
    @keyframes loadRoot {
        0%{
            max-height:0px;
        }
    }
`

const Container = styled.div`
    text-align:center;
    margin:10px;
    font-size:20px;
    display:flex;
    align-items:center;
    @media screen and (max-width:768px) {
        font-size:16px;
    }
    
    
`
const Image = styled.img`
    display:block;
    width:30px;
    height:30px;
    margin-right:15px;
`
const USS = styled.span`
    width:30px;
    color:pink;
    margin-right:8px;
`

const Country = (props) => {
    const { match: { params: { id, type } } } = props
    const parsedId = parseInt(id)
    const [state, setState] = useState({ loading: true, error: null, result: null, network: null })

    useEffect(() => {
        const getCountry = async () => {
            try {
                if (!isNaN(parsedId) && type === 'movie') {
                    const { data: { production_countries: result } } = await moviesApi.movieDetail(parsedId)
                    setState(prev => { return { ...prev, result, loading: false } })
                }
                if (!isNaN(parsedId) && type === 'show') {
                    const { data: { networks: network } } = await tvApi.tvDetail(parsedId)
                    setState(prev => { return { ...prev, network, loading: false } })
                }
            }
            catch (error) {
                setState(prev => { return { ...prev, error, loading: false } })
            }
        }
        getCountry()
    }, [parsedId, type])
    const { loading, error, result, network } = state
    return (
        loading ? null : error ? null :
            result ?
                (<Root>
                    {result && result.map((i, index) =>
                        <Container key={index}>
                            <USS>{i.iso_3166_1}</USS>
                            {i.name}
                        </Container>)}
                </Root>)
                : network ?
                    (<Root>
                        {network && network.map((i, index) =>
                            <Container key={index}>
                                <Image src={i.logo_path ? `https://image.tmdb.org/t/p/original/${i.logo_path}` : noneImage} />
                                {i.name}
                            </Container>)}
                    </Root>)
                    : null
    )
}

export default Country
